import Marquee from "react-fast-marquee";

const PHRASES = ["Connecting communities", "Opening possibilities", "Navigating opportunities"];

const Diamond = () => (
  <svg viewBox="0 0 10 10" className="h-2.5 w-2.5 mx-8 md:mx-12 shrink-0" aria-hidden="true">
    <rect x="1.8" y="1.8" width="6.4" height="6.4" transform="rotate(45 5 5)" fill="#D2A74B" />
  </svg>
);

const BrandMarquee = ({ dark = false }) => (
  <div
    className={`border-y overflow-hidden py-6 md:py-8 ${dark ? "bg-burgundy text-cream border-cream/15" : "bg-cream text-burgundy border-ink/10"}`}
    data-testid="brand-marquee"
  >
    <Marquee speed={28} gradient={false} aria-label="Connecting communities, opening possibilities, navigating opportunities">
      {[...PHRASES, ...PHRASES].map((p, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-2xl md:text-4xl tracking-tight whitespace-nowrap">
            {p}
          </span>
          <Diamond />
        </span>
      ))}
    </Marquee>
  </div>
);

export default BrandMarquee;
